import { useKestrelTutorialContext } from 'features/kestrelViewer/tutorial/KestrelTutorialContext'
import { ToolInfo } from 'features/kestrelViewer/tutorial/types'
import React, { useEffect, useState } from 'react'

import { ToolbarTooltips } from './ToolbarTooltips'

interface ToolbarTooltipsWrapperProps {
  tools: ToolInfo[]
  onNext: () => void
  onPrevious: () => void
}

export const ToolbarTooltipsWrapper: React.FC<ToolbarTooltipsWrapperProps> = ({
  tools,
  onNext,
  onPrevious,
}) => {
  const [toolbarToolIndex, setToolbarToolIndex] = useState(0)
  const { setForceViewControlsSubmenuOpen } = useKestrelTutorialContext()

  const handleNext = () => {
    if (toolbarToolIndex < tools.length - 1) {
      setToolbarToolIndex(toolbarToolIndex + 1)
    } else {
      onNext()
    }
  }

  const handlePrevious = () => {
    if (toolbarToolIndex > 0) {
      setToolbarToolIndex(toolbarToolIndex - 1)
    } else {
      onPrevious()
    }
  }

  const currentTool = tools[toolbarToolIndex]

  useEffect(() => {
    if (currentTool?.id === 'submenu-indicator') {
      setForceViewControlsSubmenuOpen(true)
    } else {
      setForceViewControlsSubmenuOpen(false)
    }
    return () => {
      setForceViewControlsSubmenuOpen(false)
    }
  }, [currentTool, setForceViewControlsSubmenuOpen])

  return (
    <ToolbarTooltips
      currentTool={currentTool}
      onNext={handleNext}
      onPrevious={handlePrevious}
    />
  )
}
